<mat-card appearance="outlined">
    <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
        <mat-card-title>Alerts</mat-card-title>

        <button *ngIf="!viewOnly" mat-fab color="primary" (click)="onAddAlertClicked()" matTooltip="Add Alert" class="addButton" telemetry="Submission-AddAlert">
            <mat-icon>add</mat-icon>
        </button>
    </mat-card-header>

    <mat-card-content [formGroup]="alertListForm" fxLayout="column" fxLayoutAlign="space-between stretch">
        <mat-progress-bar *ngIf="!isLoaded" mode="indeterminate"></mat-progress-bar>

        <div *ngIf="!hasAlerts" fxLayoutAlign="center center">
            <mat-icon>info</mat-icon>
            <strong>No alerts</strong>
        </div>

        <div *ngIf="hasAlerts" fxLayout="column">
            <ng-container *ngFor="let alertCard of alertCards">
                <alert *ngIf="!isDelete(alertCard)" formArrayName="rows" [model]="alertCard" [viewOnly]="viewOnly" (delete)="onDelete($event)">
                </alert>
            </ng-container>
        </div>
    </mat-card-content>

    <mat-card-actions align="end" class="contact-manager-actions">
        <button *ngIf="viewOnly" mat-raised-button color="primary" (click)="onClose()" telemetry="Submission-AlertClose">
            Close
        </button>

        <button *ngIf="!viewOnly" mat-button (click)="onClose()" telemetry="Submission-AlertCancel">
            Cancel
        </button>

        <button *ngIf="!viewOnly" mat-raised-button color="primary" [disabled]="alertListForm.invalid" (click)="save()" telemetry="Submission-AlertSave">
            Save
        </button>
    </mat-card-actions>
</mat-card>